module.exports = __webpack_public_path__ + "img/logo.f20e2941.png";